<template>
  <div>
    <div class="form-group">
      <label for="title">제목</label>
      <v-input
        type="text"
        id="title"
        :value="value.title"
        :errors="errors.title"
        ref="title"
        @input="update"
      />
    </div>
    <div class="form-group">
      <label for="files_1">첨부파일</label>
      <div class="row">
        <div class="col-md-3">
          <template v-for="(file, index) in files">
            <div class="form-group" :key="`file_${index}`">
              <v-input-file
                :id="`files_${index}`"
                v-model="file.file"
                @input="update"
              />
            </div>
          </template>
        </div>
        <div class="col-md-3">
          <button type="button" class="btn btn-default btn-sm" @click="addFileCount">
            +
          </button>
        </div>
      </div>
      <div v-if="file !== undefined && file.length > 0">
        <template v-for="f in file">
          <div class="form-group">
            <a :href="f.url" target="_blank" class="btn btn-default btn-sm">
              <i class="fal fa-download"></i> {{ f.name }}
            </a>
            &nbsp;
            <button type="button" class="btn btn-link btn-sm" @click="destroyAttachment(f)">
              삭제
            </button>
          </div>
        </template>
      </div>
    </div>
    <div class="form-group">
      <label for="content">간략 설명</label>
      <v-input
        type="text"
        id="content"
        :value="value.content"
        :errors="errors.content"
        ref="content"
        @input="update"
      />
    </div>
  </div>
</template>
<script>
  import {getImageButton} from '@/plugins/summernote-0.8.12-dist/buttons/image';
  import {dispatch} from "@/core/dispatcher";
  import DestroyAttachmentJob from "@/core/jobs/announcement/DestroyAttachmentJob";

  export default {
    props: ['value', 'errors', 'file'],
    data() {
      return {
        files: [
          {
            file: null
          }
        ]
      };
    },
    methods: {
      destroyAttachment(file) {
        this.$emit('destroy-attachment', file);
      },
      addFileCount() {
        this.files.push({
          file: null
        });
      },
      update() {
        this.$nextTick(() => {
          this.$emit('input', {
            title: this.$refs.title.$refs.input.value,
            content: this.$refs.content.$refs.input.value,
            files: this.files.filter(file => file.file !== null).map(file => file.file),
          });
        });
      }
    }
  }
</script>
